export const LIB_VERSION = "2.0.4";